export default __webpack_public_path__ + "static/media/search-forbidden.b7b35908.png";